import { Injectable } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseForm, FormField } from '@fry/lib/forms';

import { UserFieldsStore } from '@fry/lib/user-fields';
import { pick } from '@fry/lib/utils/common';

@Injectable()
export class UserEditForm extends BaseForm {
    constructor(
        fb: UntypedFormBuilder,
        private userFields: UserFieldsStore
    ) { super(fb); }

    _fields = [
        { id: 'email', title: $localize `Email`, initial: '',
          widget: { type: 'string', autocomplete: 'email' },
          validators: [Validators.email] },
        { id: 'firstName', title: $localize `First name`, initial: '',
          widget: { type: 'string', autocomplete: 'given-name' },
          validators: [Validators.required] },
        { id: 'lastName', title: $localize `Last name`, initial: '',
          widget: { type: 'string', autocomplete: 'family-name' },
          validators: [Validators.required] }
    ];

    private getUserFields(): Observable<FormField[]> {

        return this.userFields.all().pipe(
            map(data => {
                return data.map(item => {
                    return {
                        id: item.doc._id,
                        title: item.doc.name,
                        initial: '',
                        validators: [],
                        widget: { type: 'string' }
                    };
                });
            })
        );
    }

    getFields(): Observable<FormField[]> {
        return forkJoin([
            of(this._fields),
            this.getUserFields()
        ]).pipe(
            map(data => {
                return [].concat(...data);
            })
        );
    }

    toForm() {
        return (model, form) => {
            const ids = form.fields.map(fld => fld.id);
            const mainFieldIds = this._fields.map(item => item.id);
            const userFieldIds = ids.filter(id => mainFieldIds.indexOf(id) === -1);

            return {
                ...pick(model.doc, mainFieldIds),
                ...pick(model.userFields, userFieldIds)
            };
        };
    }

    toObject() {
        return (value, model) => {
            const ids = Object.keys(value);
            const mainFieldIds = this._fields.map(item => item.id);
            const userFieldIds = ids.filter(id => mainFieldIds.indexOf(id) === -1);
            const mainData = pick(value, mainFieldIds);
            const userFieldData = pick(value, userFieldIds);
            Object.assign(model.doc, mainData);
            Object.assign(model.userFields, userFieldData);
        };
    }
}
